<template>
  <custom-select
      v-model="valueModel"
      placeholder="请选择"
      :options="firstOptions"
      style="width: 100%; color: #697B8C; margin-left: 10px;margin-right: 10px"
      @change="changeTime"
      width="flex: 1"
  />
</template>
<script>
import CustomSelect from "@/components/customSelect/index.vue";

export default{
    name:"TimeRange",
  components: {CustomSelect},
    props:{
        value:{
            type:String,
            default:''
        }

    },
    watch:{
        value:{
            handler(v){
                this.valueModel = _.cloneDeep(v)
            },
            deep:true,
            immediate:true
        }
    },
    data(){
        return {
            firstOptions:[
                {
                    label:"30mins间隔",
                    value:"30"
                }
            ],
            valueModel:''
            
        }
    },
    created(){
        
    },
    mounted(){
        
    },
    methods:{
        changeTime(val){
            this.$emit('change',val)

        }
    }
}
</script>